import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';

interface FilterPillProps {
  label: string;
  onRemove: () => void;
}

const FilterPill: React.FC<FilterPillProps> = ({ label, onRemove }) => {
  return (
    <span className="inline-flex items-center bg-purple-100 text-purple-800 text-xs font-medium px-2 py-1 rounded-full gap-1 cursor-pointer hover:bg-purple-200 transition" onClick={onRemove}>
      {label}
      <XMarkIcon className="w-3 h-3" />
    </span>
  );
};

export default FilterPill; 